import React, { useRef, useContext, useEffect, useState } from 'react';
// import union from '@turf/union';
import omit from 'lodash/omit';
import get from 'lodash/get';
import bbox from '@turf/bbox';
import { format } from 'd3-format';
// import { useHistory } from 'react-router-dom';
// import Warning from './Warning';
import { FixedTable } from './Table';
// import { FarmContext } from './FarmContext';
import { AppContext } from './AppContext';
import { getAllFkd } from './db';
import { SelectedFKD } from './FKDProperties';
import MultiSelect from './MultiSelect';
import Slider from './Slider';

// import HistogramSlider from './HistogramSlider';

const acF = format('.2s');


const getFiltered = (allKnowledgeRef, filters) => {
  if (!allKnowledgeRef) return [];
  const filtersIds = new Set(filters.ids);
  const filtersCategories = new Set(filters.categories);
  const filtersSources = new Set(filters.sources);
  const knowledgeFiltered =  allKnowledgeRef.current.features
    .filter(f => filtersIds.has(f.properties.id))
    .filter(f => filtersCategories.size === 0 || filtersCategories.has(f.properties.category))
    .filter(f => filtersSources.size === 0 || filtersSources.has(f.properties.source))
    .filter(f => 10**filters.acres[0] <= f.properties.acres && f.properties.acres <= 10**filters.acres[1]);
  return knowledgeFiltered;
}
// new Date("2021-05-05")

export default function FKD () {
  // TODO https://github.com/pmndrs/jotai, https://github.com/pmndrs/zustand v mobx
  // TODO highlighted shouldn't be up in context need something like 
  // TODO setSelected should highlight on map
  const { highlighted, filters, setSelected, selected, setFilters, mapboxRef} = useContext(AppContext);
  const { allKnowledge, highLight, unHighLight, allKnowledgeRef } = useFKDToggle();


  // TODO use crossfilter or similar class
  // console.log(filters, knowledgeFiltered);
  // (1) date entered, (2) relevancy date (3) boundary size of information, (4) category, and (5) source. 
  const categories = Array.from(new Set(allKnowledge.features.map(f => f.properties.category))).map(c => ({value: c, label: c}));
  const sources = Array.from(new Set(allKnowledge.features.map(f => f.properties.source))).map(c => ({value: c, label: c}));

  const fmt = props => {
    return {...props, 'acres': acF(props.acres)}
  }

  const knowledge = getFiltered(allKnowledgeRef, filters).map(f => ({
      ...fmt(f.properties),
      // TODO edit
      onClick: () => setSelected(f),
      // onClick: () => history.push('/fkd/' + f.id),
      // '': <Link to={'/fkd/' + f.id} > Edit </Link>,
      onMouseEnter: () => highLight([f]),
      onMouseLeave: () => unHighLight(f),
    }));

  // if (boundary.features.length === 0) return <Warning text="No farm boundary, go and draw one on the farm map." />

  const headers = [
      'category',
      'notes',
      'date',
      'acres',
  ]

  useEffect(() => {
    const src = mapboxRef.current.getSource('filtered-fkd');
    if (src) {
      src.setData({
        type: 'FeatureCollection',
        features: getFiltered(allKnowledgeRef, filters),
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(omit(filters, 'ids'))]);
  
  if (!knowledge) return <h2 className="text-xl">
    Loading...
  </h2>

  if (selected) return <SelectedFKD selected={selected} />;

  const getColor = (r, h) => {
    if (highlighted.map(f => f.id).indexOf(r.id) > -1) return {'backgroundColor': 'pink'};
    return {};
  }

  return <div>
    <h2 className="text-xl">
      Farm Knowledge Data (intersecting the current boundary)
    </h2>

    <h5> Category </h5>
    <MultiSelect value={get(filters, 'categories', []).map(c => ({value: c, label: c}))} options={categories} onChange={(vs) => setFilters(fs => ({...fs, categories: vs.map(v => v.value)}))} />
    {/*<h5> Date </h5>*/}
    {/* <Slider fmt={v => v.toString()} values={filters.dates} setValues={(values) => setFilters(fs => ({...fs, dates: values}))} STEP={86400000*10000} MIN={new Date(2010, 1, 1)} MAX={new Date()} /> */}
    <h5> Acres </h5>
    {/* TODO default values */}
    <Slider fmt={v => (10 ** v).toFixed(0)} values={filters.acres} setValues={(values) => setFilters(fs => ({...fs, acres: values}))} STEP={1} MIN={0} MAX={9} />
    <h5> Source </h5>
    <MultiSelect value={get(filters, 'sources', []).map(c => ({value: c, label: c}))} options={sources} onChange={(vs) => setFilters(fs => ({...fs, sources: vs.map(v => v.value)}))} />
    <FixedTable headers={headers} rows={knowledge} getColor={getColor}/>
  </div>
}


const updateSource = (user, mapboxRef, allKnowledgeRef, setAllKnowledge) => {
  if (!user) return;
  getAllFkd(user)
    .then(fs => {
      // unroll each parcel/boundary
      const fc = {type: 'FeatureCollection', features: fs.map(f => {
        return {
          id: f['id'],
          type: 'Feature',
          properties: omit(f, ['boundary_set_union']),
          geometry: f['boundary_set_union']
        }
      })};
      console.log('fetched FKD', fc);
      setAllKnowledge(fc);
      allKnowledgeRef.current = fc;
      if (!mapboxRef.current) return;
      const source = mapboxRef.current.getSource('all-fkd');
      if (source) source.setData(allKnowledgeRef.current);
      const sourceFiltered = mapboxRef.current.getSource('filtered-fkd');
      if (sourceFiltered) sourceFiltered.setData(allKnowledgeRef.current);
    });
}


export const useFKDToggle = () => {
  const { user, mapboxRef, setHighlighted, setFilters } = useContext(AppContext);
  const allKnowledgeRef = useRef({type: 'FeatureCollection', features: []}); 
  const [allKnowledge, setAllKnowledge] = useState({type: 'FeatureCollection', features: []});
  // const [fkdFilter, setFkdFilter] = useState({});

  useEffect(() => {
    updateSource(user, mapboxRef, allKnowledgeRef, setAllKnowledge);
  }, [user, mapboxRef, allKnowledgeRef, setAllKnowledge]);

  const allKnowledgeToggle = (toggle) => {
    if (!mapboxRef.current) return;
    if (!mapboxRef.current.getSource('all-fkd')) {
        mapboxRef.current.addSource('all-fkd', {
          type: 'geojson',
          data: allKnowledgeRef.current,
      });
    }

    if (!mapboxRef.current.getSource('filtered-fkd')) {
        mapboxRef.current.addSource('filtered-fkd', {
          type: 'geojson',
          data: allKnowledgeRef.current,
      });
    }

    const layers = [{
      id: 'all-fkd',
      type: 'line',
      source: 'filtered-fkd',
      paint: {
        'line-color': 'pink',
        'line-width': 3,
      }
    },{
      id: 'all-fkd-fill',
      type: 'fill',
      source: 'all-fkd',
      paint: {
        "fill-color": "transparent"
      }
    },{
      id: 'all-fkd-highlight',
      type: 'fill',
      source: 'all-fkd',
      paint: {
        'fill-color': 'pink',
        'fill-opacity': 0.5
      },
      'filter': ['==', ['get', 'id'], '']
    }];

    layers.forEach(l => {
      if (mapboxRef.current.getLayer(l.id)) mapboxRef.current.removeLayer(l.id);
      if (toggle) {
        mapboxRef.current.addLayer(l);
      }
    });

    if (toggle) {
      mapboxRef.current.on('mousemove', 'all-fkd-fill', evt => {
        if (evt.features.length > 0) {
          highLight(evt.features);
        }
      })
      mapboxRef.current.on('mouseleave', 'all-fkd-fill', evt => {
        unHighLightAll();
      })
      mapboxRef.current.on('moveend', evt => {
        const [[xb1, yb1], [xb2, yb2]] = mapboxRef.current.getBounds().toArray();
        const features = mapboxRef.current.queryRenderedFeatures({layers: ['all-fkd-fill']})
          .filter(f => {
            // remove features bigger than whole screen
            const [x1, y1, x2, y2] = bbox(f);
            return (xb1 <= x1) && (x2 <= xb2) && (yb1 <= y1) && (y2 <= yb2);
          })
        
        setFilters(fs => ({...fs, ids: features.map(f => f.id)}));
      })

    } else {
      mapboxRef.current.off('mousemove', 'all-fkd-fill')
      mapboxRef.current.off('mouseleave', 'all-fkd-fill')
      // mapboxRef.current.off('moveend', 'all-fkd-fill')
    }
  }

  const highLight = fs => {
    if (!mapboxRef.current.getLayer('all-fkd-highlight')) return;
    // TODO multiple IDS
    mapboxRef.current.setFilter('all-fkd-highlight', ['in', ['to-string', ['get', 'id']], ['literal', fs.map(f => `${f.id}`)]]);
    setHighlighted(hs => [...hs, ...fs]);
  }

  const unHighLight = f => {
    if (!mapboxRef.current.getLayer('all-fkd-highlight')) return;
    mapboxRef.current.setFilter('all-fkd-highlight', ['==', ['get', 'id'], '']);
    setHighlighted(hs => hs.filter(h => h.id !== f.id));
  }

  const unHighLightAll = () => {
    if (!mapboxRef.current.getLayer('all-fkd-highlight')) return;
    mapboxRef.current.setFilter('all-fkd-highlight', ['==', ['get', 'id'], '']);
    setHighlighted([]);
  }

  return {allKnowledgeToggle, allKnowledge, highLight, unHighLight, allKnowledgeRef};
}


